import { useUIStore } from '../../stores/uiStore'
import { useServerStore } from '@/shell/stores/serverStore'
import { inviteApi } from '../../services/api'
import { useState } from 'react'
import { X, Globe } from 'lucide-react'

export default function ModalManager() {
  const { modal, closeModal } = useUIStore()

  if (!modal) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/70" onClick={closeModal} />
      <div className="relative z-10">
        {modal === 'joinServer' && <JoinServerModal onClose={closeModal} />}
      </div>
    </div>
  )
}

function JoinServerModal({ onClose }: { onClose: () => void }) {
  const [code, setCode] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { addServer } = useServerStore()

  const handleJoin = async () => {
    if (!code.trim()) return
    setLoading(true)
    setError('')
    try {
      const raw = code.trim()
      const match = raw.match(/\/invite\/([^/]+)$/)
      const inviteCode = match ? match[1] : raw
      const res = await inviteApi.join(inviteCode)
      addServer(res.data)
      onClose()
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to join server')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="bg-background rounded-lg w-[440px] p-4 shadow-xl">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-foreground">Join a Server</h2>
        <button onClick={onClose} className="text-muted-foreground hover:text-foreground"><X size={20} /></button>
      </div>
      <p className="text-muted-foreground text-sm mb-4">Enter an invite below to join an existing server</p>
      <div className="mb-4">
        <label className="block text-xs font-bold text-muted-foreground uppercase mb-1">Invite Link</label>
        <input
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder={`${window.location.origin}/invite/xxxxx`}
          className="w-full bg-card text-foreground rounded px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          onKeyDown={(e) => e.key === 'Enter' && handleJoin()}
        />
      </div>
      {error && <p className="text-destructive text-sm mb-3">{error}</p>}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2 text-muted-foreground text-sm">
          <Globe size={16} />
          <span>Your invites will show here</span>
        </div>
        <button
          onClick={handleJoin}
          disabled={loading}
          className="px-4 py-2 bg-primary text-primary-foreground rounded text-sm font-medium hover:bg-primary/90 disabled:opacity-50 transition"
        >
          {loading ? 'Joining...' : 'Join Server'}
        </button>
      </div>
    </div>
  )
}
